import React from "react"
import _ from "lodash"
import PayWallDrawer from "./PayWallDrawer"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
interface IProps {
}

const PayWall: React.SFC<IProps> = () => {
    return (location.pathname.startsWith('/schedule') && !AccountStore.getScheduleEnabled()) ?
        <PayWallDrawer
            drawerTitle={strings.Enhanced_Scheduling}
            title={strings.Ready_to_start_using_Scheduling}
            description={strings.Use_Schedule_Description}
            marketingContentHTMLUrl="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/paywall-marketing/scheduling.html"
        /> :
        (location.pathname.startsWith('/leave-tracking') && !AccountStore.getAccrualsTimeoffEnabled()) ?
            <PayWallDrawer
                drawerTitle={strings.Employee_Leave_Tracking}
                title={strings.Ready_to_start_using_leave_tracking}
                description={strings.Use_Leave_Tracking_Description}
                marketingContentHTMLUrl="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/paywall-marketing/leavetracking.html"
            /> :
            null
}

export default PayWall